import { Component, OnInit } from "@angular/core";
import { MatDialog, MatSnackBar } from "@angular/material";
import { PopoverRef } from "@mandae/ng-popover";
import { PROVIDERS } from "../../../../angularjs-app/app/common/providers.constant";
import { IntegrationService } from "../../../services/ajs-integration.service";
import { PerfilService } from "../../../services/ajs-perfil.service";
import { UiRouterState } from "../../../services/ajs-router-state.service";
import { StateParamsService } from "../../../services/ajs-state-params.service";
import { TourStep } from "../../../tour/tour-step";
import { TourService } from "../../../tour/tour.service";
import { IntegrationSetupDialogComponent } from "../integration-setup-dialog/integration-setup-dialog.component";
import { filter, tap } from "rxjs/operators";
import {
  IntegrationSetupIntroductionDialogComponent
} from "../integration-setup-introduction-dialog/integration-setup-introduction-dialog.component";

@Component({
  selector: "mandae-integration",
  templateUrl: "./integration-list.component.html",
  styleUrls: ["./integration-list.component.scss"],
})
export class IntegrationListComponent implements OnInit {
  public providers: any[] = [];

  constructor(
    private dialog: MatDialog,
    private integrationService: IntegrationService,
    private profileService: PerfilService,
    private router: UiRouterState,
    private snackBar: MatSnackBar,
    private stateParams: StateParamsService,
    private state: UiRouterState,
    private tour: TourService
  ) {}

  public async ngOnInit() {
    if (this.stateParams.showAlert) {
      this.snackBar.open("Alterado com sucesso!", undefined, {
        duration: 2500,
      });
    }

    if (this.stateParams.showSetupDialog) {
      this.dialog
        .open(IntegrationSetupIntroductionDialogComponent, {
          closeOnNavigation: true,
          width: "600px",
          maxWidth: "95vw",
          data: {},
        })
        .afterClosed()
        .pipe(
          filter((result) => result),
          tap(() => {
            this.dialog.open(IntegrationSetupDialogComponent, {
              minWidth: 1128,
              maxHeight: "90vh",
            });
          })
        )
        .subscribe();
    }

    try {
      const permissions = (await this.profileService.getBetaFeatures())
        .funcionalidades;
      this.providers = this.integrationService.getEnabledProviders(permissions);

      await this.integrationService.tryAuthorizeAccountsBatch(this.providers);

      if (this.stateParams.tour) {
        this.startTour();
      }
    } catch (e) {
      this.snackBar.open("Ocorreu um erro interno na aplicação", "Fechar", {
        duration: 2500,
      });
    }
  }

  public async connectIntegration(provider) {
    try {
      await this.integrationService.connect(provider);
    } catch (e) {
      this.snackBar.open("Ocorreu um erro interno na aplicação", "Fechar", {
        duration: 2500,
      });
    }
  }

  public async disconnectIntegration(provider) {
    provider.isLoading = true;

    try {
      await this.integrationService.disconnect(provider.slug);
      await this.integrationService.tryAuthorizeAccount(provider.slug);
    } catch (e) {
      if (e.textStatus) {
        this.snackBar.open(e.textStatus, "Fechar", {
          duration: 2500,
        });
      }
    }
  }

  public gotoIntegrationSettings(slug: string) {
    this.router.go("integration-config", { provider: slug });
  }

  public hasConfig(provider) {
    const configExists = PROVIDERS.some(
      (p) => provider.slug === p.slug && p.config
    );
    return configExists && !provider.isLoading && provider.isAuthorized;
  }

  private startTour() {
    const next = {
      text: "Ir para API",
      action: (ev: MouseEvent, ref: PopoverRef) => {
        ref.close("to_next_section");
        this.state.go("api-config", { tour: true });
      },
    };

    const stepsConfig: TourStep[] = [
      {
        title: "Integre com a Mandaê",
        text: "Conecte sua loja à Mandaê e importe os seus pedidos.",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            "app-toolbar .mat-tab-link:nth-child(4)"
          ),
        previous: {
          text: "Voltar",
          action: (ev, ref) => {
            ref.close("to_previous_section");
            this.state.go("enderecos", { tour: true });
          },
        },
      },
    ];

    if (this.providers.some((provider) => provider.isAuthorized)) {
      stepsConfig.push({
        title: "Configurações da plataforma",
        text:
          "Aqui você pode alterar a situação das vendas na sua plataforma," +
          " configurações de serviço de envio padrão e seguro do extravio",
        attachTarget: () => document.querySelector(".btn-configuracoes"),
        next,
      });
    } else {
      stepsConfig[0].next = next;
    }

    const steps = this.tour.makeTour(stepsConfig);

    this.tour.start(steps).subscribe();
  }
}
